import React from 'react';
import { Anchor, Col, Icons, OffCanvas, Row, Selectable } from '@mirohq-internal/website-ui-foundation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var OffCanvasLanguageList = function OffCanvasLanguageList(_ref) {
  var className = _ref.className,
      show = _ref.show,
      title = _ref.title,
      items = _ref.items,
      selectedValue = _ref.selectedValue,
      handleClose = _ref.handleClose,
      handleSelect = _ref.handleSelect;
  return /*#__PURE__*/_jsxs(OffCanvas, {
    "data-testid": "off-canvas-language-list",
    className: className,
    backdropClassName: className,
    show: show,
    placement: "bottom",
    handleClose: handleClose,
    children: [/*#__PURE__*/_jsxs(OffCanvas.Header, {
      className: "text-primary",
      children: [/*#__PURE__*/_jsx(OffCanvas.Title, {
        children: title
      }), /*#__PURE__*/_jsx(Anchor, {
        withHoverBg: true,
        onClick: handleClose,
        children: /*#__PURE__*/_jsx(Icons.Cross, {
          size: "md"
        })
      })]
    }), /*#__PURE__*/_jsx(OffCanvas.Body, {
      children: /*#__PURE__*/_jsx(Row, {
        className: "d-flex gap-600",
        children: /*#__PURE__*/_jsx(Col, {
          className: "d-flex flex-column gap-400",
          children: items.map(function (item) {
            return /*#__PURE__*/_jsx(Selectable, {
              onSelect: handleSelect,
              selected: selectedValue === item.label,
              selectedIcon: "CheckMark",
              href: item.href,
              eventKey: item.label,
              children: item.label
            }, item.label);
          })
        })
      })
    })]
  });
};